import { AppAbility, UserAbility } from "./AppAbility.ts";

export const initialAbility: UserAbility[] = [
  {
    action: "read",
    subject: "Auth",
  },
];

const stringifiedUserAbilities = localStorage.getItem("userAbilities");
const existingAbility = stringifiedUserAbilities
  ? JSON.parse(stringifiedUserAbilities)
  : null;

export default AppAbility.update(existingAbility || initialAbility);
